#import "./account-fragment.graphql"
#import "./activity-fragment.graphql"
#import "./contact-fragment.graphql"
#import "./lead-fragment.graphql"

fragment NoteFragment on Note {
    id
    bodyHtml
    htmlUrlPath
    htmlUrl
    isEditable
    hasMentionedEntities
    isDeleted
    entity {
        ... on Account {
            ...AccountFragment
        }
        ... on Activity {
            ...ActivityFragment
        }
        ... on Contact {
            ...ContactFragment
        }
        ... on Lead {
            ...LeadFragment
        }
    }
}
